module.exports = __webpack_public_path__ + "static/media/default-avatar.9d137006.png";